import { createSlice } from '@reduxjs/toolkit'
import { STATUS } from 'Reducers/actions/supplierActions'

export const supplierSlice = createSlice({
  name: 'supplier',
  initialState: {
    overviewLoadingState: false,
    suppliers: [],
    carriers: [],
    supplierDetails: {
      supplierName: '',
      supplierUID: '',
      CarrierID: 0,
      isDropship: 0,
      orderType: 'EMAIL',
      deliveryTimeDaysMin: 0,
      deliveryTimeDaysMax: 0,
      minOrderAmountDkk: 0,
      purchaseConditions: '',
      accesses: [],
      freightIntervals: []
    },
    loadingState: false,
    showActiveSuppliers: true,
    showInActiveSuppliers: false,
    supplierFilterValue: 'active'
  },
  reducers: {
    fetchSuppliersRequest: state => {
      state.overviewLoadingState = STATUS.FETCHING_SUPPLIERS
    },
    fetchSuppliersFailed: state => {
      state.overviewLoadingState = STATUS.FETCHING_SUPPLIERS_FAILED
    },
    fetchSuppliersSuccess: (state, action) => {
      state.suppliers = action.payload
      state.overviewLoadingState = STATUS.FETCHING_SUPPLIERS_SUCCESS
    },
    fetchSupplierDetailsRequest: state => {
      state.loadingState = STATUS.FETCHING_SUPPLIER_DETAILS
    },
    fetchSupplierDetailsFailed: state => {
      state.loadingState = STATUS.FETCHING_SUPPLIER_DETAILS_FAILED
    },
    fetchSupplierDetailsSuccess: (state, action) => {
      state.loadingState = STATUS.FETCHING_SUPPLIER_DETAILS_SUCCESS
      state.supplierDetails = action.payload
    },
    supplierCreationSuccess: (state, action) => {
      state.loadingState = action.payload
      state.loadingState = STATUS.SUPPLIER_SUCCESS
    },
    supplierCreationFailure: state => {
      state.loadingState = STATUS.SUPPLIER_FAILED
    },
    isSavingSupplier: state => {
      state.loadingState = STATUS.IS_SAVING
    },
    createEmptySupplier: state => {
      state.supplierDetails = {
        supplierName: '',
        supplierUID: '',
        CarrierID: 0,
        isDropship: 0,
        orderType: 'EMAIL',
        deliveryTimeDaysMin: 0,
        deliveryTimeDaysMax: 0,
        minOrderAmountDkk: 0,
        purchaseConditions: '',
        accesses: [],
        freightIntervals: []
      }
    },
    clearToast: (state, action) => {
      state.loadingState = action.payload ? action.payload : null
      state.overviewLoadingState = false
    },
    updateSupplierField: (state, action) => {
      return {
        ...state,
        supplierDetails: { ...state.supplierDetails, [action.payload.name]: action.payload.value }
      }
    },
    removeSupplierFailure: state => {
      state.overviewLoadingState = STATUS.DELETE_SUPPLIER_FAILED
    },
    removeSupplierSuccess: state => {
      state.overviewLoadingState = STATUS.DELETE_SUPPLIER_SUCCESS
    },
    toggleActiveSupplier: state => {
      let value = !state.showActiveSuppliers ? 'active' : 'both'
      state.showActiveSuppliers = !state.showActiveSuppliers
      state.supplierFilterValue = value
      state.showInActiveSuppliers = false
    },
    toggleInActiveSupplier: state => {
      let value = state.showInActiveSuppliers ? 'both' : 'inactive'
      state.showInActiveSuppliers = !state.showInActiveSuppliers
      state.supplierFilterValue = value
      state.showActiveSuppliers = false
    },
    updateSupplierAccess: (state, action) => {
      const supplierAccess = action.payload.access
      const index = action.payload.index

      if (index >= 0) {
        state.supplierDetails.accesses = state.supplierDetails.accesses.map((a, i) => {
          if (i === index) {
            return supplierAccess
          } else {
            return a
          }
        })
      } else {
        state.supplierDetails.accesses = [...state.supplierDetails.accesses, supplierAccess]
      }
    },
    removeSupplierAccess: (state, action) => {
      state.supplierDetails.accesses = state.supplierDetails.accesses.filter((_, i) => i !== action.payload)
    },
    updateFreightInterval: (state, action) => {
      const freightInterval = action.payload.freightInterval
      const index = action.payload.index

      if (index >= 0) {
        state.supplierDetails.freightIntervals = state.supplierDetails.freightIntervals.map((fi, i) => {
          if (i === index) {
            return freightInterval
          } else {
            return fi
          }
        })
      } else {
        state.supplierDetails.freightIntervals = [...state.supplierDetails.freightIntervals, freightInterval]
      }
    },
    removeFreightInterval: (state, action) => {
      state.supplierDetails.freightIntervals = state.supplierDetails.freightIntervals.filter((_, i) => i !== action.payload)
    },
    fetchCarriersSuccess: (state, action) => {
      state.carriers = action.payload
    }
  }
})

export const {
  fetchSuppliersRequest,
  fetchSuppliersFailed,
  fetchSuppliersSuccess,
  fetchSupplierDetailsRequest,
  fetchSupplierDetailsFailed,
  fetchSupplierDetailsSuccess,
  supplierCreationSuccess,
  supplierCreationFailure,
  toggleActiveSupplier,
  toggleInActiveSupplier,
  removeSupplierFailure,
  resetSupplierDetails,
  isSavingSupplier,
  createEmptySupplier,
  clearToast,
  updateSupplierField,
  removeSupplierSuccess,
  updateSupplierAccess,
  removeSupplierAccess,
  updateFreightInterval,
  removeFreightInterval,
  fetchCarriersSuccess
} = supplierSlice.actions

export default supplierSlice.reducer
